// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"144\" height=\"140\" fill=\"none\"><path d=\"M0 3a3 3 0 013-3h138a3 3 0 013 3v137H0V3z\" fill=\"#fff\"/><path d=\"M25 24h94v6H25v-6zM0 139h144v1H0v-1zM119 68H25v6h94v-6zM25 82h84v6H25v-6zM119 96H25v6h94v-6zM25 110h84v6H25v-6zM92 38H52v6h40v-6z\" fill=\"#E6EBF4\"/></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.related-example {
	height: 160px;
	width: 100%;
	margin: 16px 0;
	padding: 20px;
	background-color: #F2F5FA;
	background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
	background-position: 16px bottom;
	background-size: 144px 140px;
	background-repeat: no-repeat;
	border-radius: 6px;
	font-family: sans-serif;
	padding-left: 176px;
	overflow: hidden;
	position: relative;
}

.related-example::before {
	content: 'Related example';
	display: block;
	margin-bottom: 8px;
	text-transform: uppercase;
	letter-spacing: 0.07em;
	color: #7A8599;
	font-size: 10px;
	line-height: 1.4;
}

.related-example::after {
	content: '';
	display: block;
	position: absolute;
	right: 0;
	bottom: 0;
	width: calc(100% - 160px);
	height: 40px;
	background-image: linear-gradient(0deg, #f2f5fa 12px, transparent);
	z-index: 10;
}

.related-example__title {
	margin-bottom: 8px;
	font-size: 16px;
	font-weight: bold;
	line-height: 1.25;
	color: #4F5259;
}

.related-example__description {
	font-size: 13px;
	line-height: 1.23;
	color: #7A8599;
}
`, "",{"version":3,"sources":["webpack://./src/plugins/related-example/styles.css"],"names":[],"mappings":"AAAA;CACC,aAAa;CACb,WAAW;CACX,cAAc;CACd,aAAa;CACb,yBAAyB;CACzB,yDAA4V;CAC5V,gCAAgC;CAChC,4BAA4B;CAC5B,4BAA4B;CAC5B,kBAAkB;CAClB,uBAAuB;CACvB,mBAAmB;CACnB,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,0BAA0B;CAC1B,cAAc;CACd,kBAAkB;CAClB,yBAAyB;CACzB,sBAAsB;CACtB,cAAc;CACd,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,WAAW;CACX,cAAc;CACd,kBAAkB;CAClB,QAAQ;CACR,SAAS;CACT,yBAAyB;CACzB,YAAY;CACZ,kEAAkE;CAClE,WAAW;AACZ;;AAEA;CACC,kBAAkB;CAClB,eAAe;CACf,iBAAiB;CACjB,iBAAiB;CACjB,cAAc;AACf;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,cAAc;AACf","sourcesContent":[".related-example {\n\theight: 160px;\n\twidth: 100%;\n\tmargin: 16px 0;\n\tpadding: 20px;\n\tbackground-color: #F2F5FA;\n\tbackground-image: url('data:image/svg+xml,<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"144\" height=\"140\" fill=\"none\"><path d=\"M0 3a3 3 0 013-3h138a3 3 0 013 3v137H0V3z\" fill=\"#fff\"/><path d=\"M25 24h94v6H25v-6zM0 139h144v1H0v-1zM119 68H25v6h94v-6zM25 82h84v6H25v-6zM119 96H25v6h94v-6zM25 110h84v6H25v-6zM92 38H52v6h40v-6z\" fill=\"#E6EBF4\"/></svg>');\n\tbackground-position: 16px bottom;\n\tbackground-size: 144px 140px;\n\tbackground-repeat: no-repeat;\n\tborder-radius: 6px;\n\tfont-family: sans-serif;\n\tpadding-left: 176px;\n\toverflow: hidden;\n\tposition: relative;\n}\n\n.related-example::before {\n\tcontent: 'Related example';\n\tdisplay: block;\n\tmargin-bottom: 8px;\n\ttext-transform: uppercase;\n\tletter-spacing: 0.07em;\n\tcolor: #7A8599;\n\tfont-size: 10px;\n\tline-height: 1.4;\n}\n\n.related-example::after {\n\tcontent: '';\n\tdisplay: block;\n\tposition: absolute;\n\tright: 0;\n\tbottom: 0;\n\twidth: calc(100% - 160px);\n\theight: 40px;\n\tbackground-image: linear-gradient(0deg, #f2f5fa 12px, transparent);\n\tz-index: 10;\n}\n\n.related-example__title {\n\tmargin-bottom: 8px;\n\tfont-size: 16px;\n\tfont-weight: bold;\n\tline-height: 1.25;\n\tcolor: #4F5259;\n}\n\n.related-example__description {\n\tfont-size: 13px;\n\tline-height: 1.23;\n\tcolor: #7A8599;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
